/* ==========================================================================
   Parker & Rose — bundelkiezer op de productpagina
   --------------------------------------------------------------------------
   Hoort bij snippets/pr-bundle.liquid. Staat alleen op producten met de tag
   die het blok gebruikt (standaard offer-1plus1).

   Werking: de klant kiest een balk (1+1, 2+2, 3+3), krijgt per stuk een eigen
   kleur- en maatkeuze, en drukt op toevoegen. Dan gaan alle stuks in één
   /cart/add.js call de winkelwagen in.

   Het belangrijkste stuk staat onderaan: verifyAgainstCart(). De prijs die dit
   blok vóór het toevoegen toont is een eigen berekening, maar de korting komt
   van Shopify. Die twee kunnen uit elkaar lopen — korting verlopen, aangepast,
   of een andere korting wint. Daarom lezen we na het toevoegen /cart.js terug
   en vergelijken we wat er werkelijk gerekend is met wat we beloofden. Wijkt
   het af, dan zegt het blok dat, in plaats van een verkeerde prijs te laten
   staan die de klant pas bij de kassa ontdekt.
   ========================================================================== */

(function () {
  'use strict';

  function money(cents) {
    var f = (window.theme && theme.moneyFormat) || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole);
  }

  function Bundle(root) {
    this.root = root;
    this.bars = [].slice.call(root.querySelectorAll('[data-pr-bar]'));
    this.itemRows = [].slice.call(root.querySelectorAll('[data-pr-item]'));
    this.form = root.querySelector('[data-pr-form]');
    this.button = root.querySelector('[data-pr-add]');
    this.note = root.querySelector('[data-pr-note]');
    this.qty = 0;
    this.payUnits = 0;
    this.busy = false;

    var json = root.querySelector('[data-pr-variants]');
    try {
      this.variants = JSON.parse(json.textContent);
    } catch (e) {
      this.variants = [];
    }

    if (!this.variants.length || !this.bars.length) return;

    this.bind();
    this.selectBar(this.bars[0]);
  }

  Bundle.prototype.bind = function () {
    var self = this;

    this.bars.forEach(function (bar) {
      bar.addEventListener('click', function () { self.selectBar(bar); });
    });

    this.root.addEventListener('change', function (evt) {
      if (evt.target.matches('[data-pr-select]')) self.refresh();
    });

    /* Klikken op de knop, niet alleen submit: op sommige sjablonen komt het
       submit-event niet door omdat een ouder de klik afvangt. */
    this.button.addEventListener('click', function (evt) {
      evt.preventDefault();
      self.addToCart();
    });
    this.form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      self.addToCart();
    });
  };

  Bundle.prototype.selectBar = function (bar) {
    this.bars.forEach(function (b) {
      var on = b === bar;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    this.qty = parseInt(bar.getAttribute('data-qty'), 10) || 0;
    this.payUnits = parseInt(bar.getAttribute('data-pay-units'), 10) || 0;

    for (var i = 0; i < this.itemRows.length; i++) {
      this.itemRows[i].hidden = i >= this.qty;
    }

    this.clearNote();
    this.refresh();
  };

  /* De gekozen optiewaarden van één rij. */
  Bundle.prototype.rowValues = function (row) {
    return [].slice.call(row.querySelectorAll('[data-pr-select]')).map(function (s) {
      return s.value;
    });
  };

  Bundle.prototype.variantFor = function (values) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      var same = true;
      for (var o = 0; o < values.length; o++) {
        if (v.o[o] !== values[o]) { same = false; break; }
      }
      if (same) return v;
    }
    return null;
  };

  /* Prijs en beschikbaarheid bijwerken voor de zichtbare rijen. */
  Bundle.prototype.refresh = function () {
    var total = 0;
    var unavailable = 0;
    var rows = this.itemRows.slice(0, this.qty);

    for (var i = 0; i < rows.length; i++) {
      var v = this.variantFor(this.rowValues(rows[i]));
      rows[i].classList.toggle('is-unavailable', !v || !v.a);
      if (!v || !v.a) unavailable++;
      total += v ? v.p : 0;
    }

    /* Bij N stuks zijn er floor(N/2) gratis. Shopify laat de goedkoopste
       vallen, dus we tellen de duurste helft. */
    var prices = rows.map(function (r) {
      var v = this.variantFor(this.rowValues(r));
      return v ? v.p : 0;
    }, this).sort(function (a, b) { return b - a; });

    var pay = 0;
    for (var k = 0; k < this.payUnits && k < prices.length; k++) pay += prices[k];

    var bar = this.root.querySelector('.pr-bundle__bar.is-selected');
    if (bar) {
      var now = bar.querySelector('[data-pr-now]');
      var was = bar.querySelector('[data-pr-was]');
      if (now) now.textContent = money(pay);
      if (was) was.textContent = money(total);
    }

    this.button.disabled = unavailable > 0;
    if (unavailable > 0) {
      this.showNote('One of the combinations you picked is not available. Choose another colour or size.');
    } else {
      this.clearNote();
    }

    this.expected = pay;
  };

  Bundle.prototype.showNote = function (text, kind) {
    if (!this.note) return;
    this.note.textContent = text;
    this.note.hidden = false;
    this.note.className = 'pr-bundle__note' + (kind ? ' pr-bundle__note--' + kind : '');
  };

  Bundle.prototype.clearNote = function () {
    if (!this.note) return;
    this.note.hidden = true;
    this.note.textContent = '';
  };

  Bundle.prototype.addToCart = function () {
    if (this.busy || this.button.disabled) return;

    var rows = this.itemRows.slice(0, this.qty);
    var items = [];
    for (var i = 0; i < rows.length; i++) {
      var v = this.variantFor(this.rowValues(rows[i]));
      if (!v || !v.a) {
        this.showNote('One of the combinations you picked is not available.', 'warn');
        return;
      }
      items.push({ id: v.id, quantity: 1 });
    }
    if (!items.length) return;

    var self = this;
    this.busy = true;
    this.button.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        self.busy = false;
        self.button.classList.remove('is-busy');
        if (!res.ok) {
          self.showNote((res.body && res.body.description) || 'Could not add to bag.', 'warn');
          return;
        }
        self.verifyAgainstCart();
      })
      .catch(function () {
        self.busy = false;
        self.button.classList.remove('is-busy');
        window.location = self.root.getAttribute('data-product-url');
      });
  };

  /* Hier gaat het om: niet onze eigen som tonen, maar die van Shopify. */
  Bundle.prototype.verifyAgainstCart = function () {
    var self = this;
    var productId = parseInt(this.root.getAttribute('data-product-id'), 10);

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var charged = 0;
        var counted = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].product_id === productId) {
            charged += cart.items[i].final_line_price;
            counted += cart.items[i].quantity;
          }
        }

        var bubbles = document.querySelectorAll('.cart-link__bubble');
        for (var b = 0; b < bubbles.length; b++) {
          bubbles[b].classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        }

        /* Alleen zinnig vergelijken als deze bundel de enige regels van dit
           product in de winkelwagen zijn. Lag er al iets in, dan zegt het
           verschil niets en houden we onze mond. */
        if (counted !== self.qty) {
          self.showNote('Added to your bag.', 'ok');
          return;
        }

        if (Math.abs(charged - self.expected) <= 1) {
          self.showNote('Added — ' + money(charged) + ' for ' + counted + ' items.', 'ok');
        } else {
          self.showNote(
            'Added, but the bag shows ' + money(charged) + ' instead of ' + money(self.expected) +
            '. Please check your bag before paying.',
            'warn'
          );
        }
      })
      .catch(function () {
        self.showNote('Added to your bag.', 'ok');
      });
  };

  function init() {
    var blocks = document.querySelectorAll('[data-pr-bundle]');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].hasAttribute('data-pr-ready')) continue;
      blocks[i].setAttribute('data-pr-ready', '');
      new Bundle(blocks[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* De theme editor en variantwissels bouwen het blok opnieuw op. */
  document.addEventListener('shopify:section:load', init);
  if (window.MutationObserver) {
    new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
  }
})();
